export default {
  national: "national",
  regional: "region",
  school: "institution",
  day: "Day",
  days: "Days",
  week: "Week",
  month: "Month",
  listening: "Listening",
  speaking: "Speaking",
  reading: "Reading",
  writing: "Writing",
  points: "Points",
  hours: "Hours",
  dismiss: "Dismiss",
  close: "Close",
  record: "Record",
  listen: "Listen",
  repeat: "Repeat",
  translate: "Translate",
  timer: "Timer",
  next: "Next",
  validate: "Validate",
  you: "Mine",
  native: "Native",
  checkText: "Check the text again",
  congratulations: "Congratulations",
  needHelp: "Do you need help?",
  instructions: "Instructions",
  continue: "Continue",
  userSnapButton: "Report Error",
  startIntroductionButton: "Start Introduction",
  preview: "Preview",
  download: "Download",
  open: "Open",
  certificationTest: {
    created:
      "You are able to do Certification Test. Talk to your teacher to scheduled it, meanwhile continue studying to be prepared.",
    scheduled: "Your Certification Test is scheduled to {scheduledTo} ",
    enabled: "Your Certification Test is available.",
    continue: "Continue your Certification Test.",
    awaitingRevision: "Soon, your certification test will be reviewed. In few days, you will receive the result.",
    reviewed: "Your Certification test was reviewed.",
    failed: "You didn't achieve the minimum score in your last Certification Test.",
    button: {
      start: "START CERTIFICATION TEST",
      continue: "CONTINUE CERTIFICATION TEST",
      reviewed: "CHECK RESULTADO",
      back: "Back to home",
      access: "Access",
      accessNewCourse: "Access the new course",
    },
    execution: {
      title: "Reach the minimum score of 70 to enable the next step that is locked",
      completedTitle: "Certification test completed and submitted for review",
      completedDescription:
        "Once the evaluator reviews your test, you'll receive a notification with your grade!\n Good Luck!",
      ability: {
        reading: "Reading test",
        writing: "Writing test",
        speaking: "Speaking test",
        listening: "Listening test",
      },
      status: {
        finished: "Done",
        available: "Start",
        blocked: "Locked",
      },
    },
    result: {
      failedTitle: "Oh no...",
      failedDescription: "You have not reached the required grade to pass in the certification test",
      failedDescriptionTwo: "Talk to you teacher to understand your errors and try again.",
      approvedTitle: "Great!",
      approvedDescription: "You have reached the grade required to pass the certification test",
      approvedDescriptionTwo:
        "You have proved to us that you have raised an English level on the Common European Framework of Reference for Languages scale.",
      scoreBySkill: "Score by skill",
      finalScore: "Final score",
      unlockedCourse: "Unlocked course",
    },
    help: {
      gotIt: "Ok, got it",
      free_speak:
        "In this exercise, unlike units, you should not repeat the question on the screen, but rather answer it. You will have up to 1 minute to think about your answer before the Record starts automatically. If you wish, you can also start sooner.",
      free_speak_image:
        "In this exercise, you should describe the image on the screen. You will have up to 1 minute to think about your answer before the Record starts automatically. If you wish, you can also start sooner.",
    },
  },
  help: {
    DICTATION: "Listen carefully to native audio and <b>write</b> the phrase in the field below.",
    GAP_FILL_MULTIPLE: "Complete the phrase <b>by dragging</b> the correct words into the available spaces.",
    UNSCRAMBLE_DRAG_AND_DROP: "Unscramble the phrase <b>by dragging</b> the correct words into the available spaces.",
    PRESENTATION:
      "Use the Repeat, Record and Listen buttons to <b>record your voice</b> by repeating the native audio.",
    PRONUNCIATION: "Use the Record to <b>speak the text</b> below.",
    GAP_FILL_SELECT: "Complete the phrase <b>by selecting</b> one of the available options.",
    SINGLE_CHOICE_AUDIO: "Listen to the question and <b>click</b> in the correct option.",
    SINGLE_CHOICE_TEXT: "Listen to the question and <b>click</b> in the correct option.",
    SINGLE_CHOICE_IMAGE: "Listen to the question and <b>click</b> in the correct option.",
    SPEECH_PRACTICE: "<b>Listen</b> carefully and use the Record to <b>repeat</b> the audio.",
    GAP_FILL: "Record the <b>entire</b> phrase with the correct option.",
    UNSCRAMBLE_SPEECH_RECOGNITION:
      "Unscramble the phrase using the Record to <b>record the phrase</b> in the correct sequence.",
    TEXT: "<b>Read the text carefully </b> and then use the Next to continue.",
    TRUE_FALSE: "Listen to the statement and <b>click </b> in the true or false button.",
  },
  items: {
    correctAnswer: "Correct answer: ",
    placeholder: {
      gapFillSelect: "Select an option",
      freeSpeak: "In {time} seconds the Record will start automatically. If you want, you can start before.",
    },
    dictation: {
      errorTitle: "Check the list below to understand your errors",
      moreWordsError: "Your phrase has {count} more words than needed",
      missingWordsError: "Your phrase has {count} missing words",
      wordsWithTyposError: "Words with typos: ",
      wrongWordsError: "Wrong Words: ",
    },
    speechRecognition: {
      historyTitle: "Your score history",
      tryAgain: "Try Again!",
      errorLowScore: "We could not generate a score for your speech, please try again.",
      errorNoSpeech: "We could not detect any speech, please try again.",
    },
  },
  intro: {
    next: "Next",
    previous: "Previous",
    skip: "Skip",
    done: "End",
    gotIt: "Got it",
    steps: {
      gapFillSelect: "Select an option to complete the phrase.",
      singleChoiceImage: "Listen to the audio and select the correct image.",
      singleChoiceText: "Listen to the audio and select the correct option.",
      singleChoiceAudio: "Listen to the audio and select the correct option.",
      gapFill1: "The text is incomplete. You need to complete it by selecting one of the options.",
      gapFill2: "Click to select one of the options.",
      unscrambleDragDrop1: "Here you need to unscramble the phrase using the available options.",
      unscrambleDragDrop2: "These are the available options. Drag them to create the correct phrase!",
      gapFillMultiple1: "The text is incomplete. You need to complete it with the correct options.",
      gapFillMultiple2: "These are the options. Drag them to create the correct phrase!",
      controlBar1: "Button to repeat the audio. Remember, you just can use it once!",
      controlBar2: "The maximum time for each question. It will start after the complete load of the question.",
    },
  },
  login: {
    email: "Email",
    password: "Password",
    enter: "Enter",
    forgotPassword: "Forgot my password",
    forgotPasswordDescription: "Inform your email in the below field and we will send an email with your new password.",
    forgotPasswordPostDescription: "You can change the new password in the update profile option in your profile page.",
    backToLogin: "Back to Login",
    resetPassword: "Reset Password",
    resetPasswordSuccess: "Your new password was sent by email.",
    unexpected_error: "It was not possible to sign in. Try again later.",
    email_not_found: "Email not found.",
    user_not_found_in_distributor: "Email not found.",
    user_not_found_in_company: "Email not found.",
    invalid_password: "Invalid password.",
    classroom_not_found: "Your account does not have a classroom.",
    inactive_classroom: "Classroom inactive.",
    user_with_placement_in_classroom: "You already finished your Placement Test.",
    user_disabled: "Account disabled. Check with you institution.",
    payment_required: "You have a pending payment. Check your email or contact our support.",
    limit_reached: "All available accounts have been filled.",
    student_contract_blocked:
      "Oops, looks like your access has been blocked. Contact your teacher for more information.",
  },
  error: {
    required: "Required",
    invalidEmail: "Invalid email",
    differentPasswords: "The passwords are not the same",
    audioDownload: "There was a problem to play the audio. Try again using the Repeat button.",
    noSpeechDetected:
      "It was not possible to detect your speak. Check your microphone, it can be muted or configured with a very low sensitivity. Also try to listen to your speak to check if it is ok.",
    generalConnectionError: "We had an connection instability. Please try again this exercise.",
    generateUnitScore: "There was a problem to generate your score.",
    emailPasswordInvalid: "Check your email and/or password.",
    emailNotFound: "We could not find an user for the informed email.",
    duplicatedEmail: "The provided email already exists in our database.",
    updateProfileError: "We got an unexpected problem to update your account.",
    updateAvatarError: "We got an unexpected problem to update your avatar.",
    checkBrowserType: {
      title: "Sorry, your current web browser is not supported by us.",
      description1:
        "You can have a better experience in our platform using the latest version of Google Chrome web browser.",
      description2: "You can also use the Mozila Firefox or Safari.",
    },
    checkBrowserVersion: {
      title: "Your web browser is out of date.",
      description:
        "You can have a better experience using the latest version of your web browser. You can download it in this {link}.",
    },
    checkAudioPermission: {
      title: "Almost Finished",
      description:
        "Sorry, we detected you are using the {browserName} web browser and our site does not have the permissions to auto play the audios.",
      safari: {
        description: "Follow the steps below to enable the auto play for audios:",
        step1: "Right click on address bar and select the option: <b>Settings for this Website</b>",
        step2: "On Auto-Play select the option: <b>Allow All Auto-Play</b>",
        step3: "Refresh your page and you will be ready to start",
      },
      chrome: {
        description: "Press the button below and continue.",
        button: "Allow and go",
      },
    },
    error_play_audio: "There was a problem to play the native audio. Try again using the repeat button",
    error_play_record: "There was a problem to play your record. Try again using the listen button",
    error_start_record: "There was a problem to access your microphone. Try again using the record button",
    error_stop_record: "There was a problem to end your record. Try again using the record button",
    error_find_speech_recognition_text: "There was a problem to find your answer. Try again using the record button",
    error_get_speech_recognition_score:
      "There was a problem to define your speech score. Try again using the record button",
    error_no_speech: "We could not detect your speech. Try again using the record button",
    error_save_answer: "There was a problem to store your answer. Try to confirm it again",
    error_inspect_html: "It is not allowed to inspect the site. The progress will be lost.",
    error_record_not_allowed:
      "We do not have the permission to access your microphone. Check the permissions of your browser.",
    error_record_missing_mic: "It was not possible to access your microphone. Check your browser configurations.",
    three_minute_block:
      "You just finished the exercise. Now you need to wait 3 minutes to do it again, but you can do any other exercise meanwhile.",
    error_browser_block_autoplay: "Click the button below to continue your exercise.",
    error_browser_block_intro_autoplay: "Let's start! Click in the button below and follow the instructions.",
    error_reply_ct_speak: "It looks like you repeated the questions instead of answering it. Record your answer again.",
    high_inactive_time: "It looks like you have been inactive for a long time.",
  },
  closeExecution: {
    title: "Attention",
    defaultMessage: "If you leave now, your study progress may be lost. Are you sure want to leave?",
    noProgressLossMessage: "Are you sure want to leave?",
    masteryMessage:
      "If you leave now, your Mastery Test will be set as failed and you will need to finished units to enable it again. Are you sure want to leave?",
    yes: "Yes",
    no: "No",
  },
  requireDesktop: {
    title: "Oops! Something went wrong",
    desktopRequiredCard: {
      title: "You need to use a computer",
      description:
        "Use a computer to take your certification test. Using a computer will give you a better experience and allow you to take your test with ease.",
    },
  },
};
